{
  "dashboard": "Auditor Dashboard",
  "assignments": "Assignments",
  "reviews": "Reviews",
  "sidebar": {
    "dashboard": "Dashboard",
    "assigned_projects": "Assigned Projects",
    "verification_reports": "Verification Reports",
    "validation_schedule": "Validation Schedule",
    "settings": "Settings"
  },
  "dashboard_page": {
    "title": "Auditor Dashboard",
    "subtitle": "Manage project validations and verification reports",
    "stats": {
      "assigned_projects": "Assigned Projects",
      "pending_reviews": "Pending Reviews",
      "completed_reports": "Completed Reports",
      "validation_score": "Validation Score"
    },
    "assigned_projects": {
      "title": "Assigned Projects",
      "view_all": "View All",
      "validation_due": "Validation Due",
      "in_progress": "In Progress",
      "completed": "Completed",
      "due": "Due",
      "started": "Started"
    },
    "validation_status": {
      "title": "Validation Status",
      "projects_validated": "Projects Validated",
      "reports_submitted": "Reports Submitted",
      "compliance_rate": "Compliance Rate"
    },
    "recent_reports": {
      "title": "Recent Verification Reports",
      "upload_report": "Upload Report",
      "project": "Project",
      "type": "Type",
      "status": "Status",
      "date": "Date",
      "actions": "Actions",
      "validation_report": "Validation Report",
      "verification_report": "Verification Report",
      "approved": "Approved",
      "under_review": "Under Review"
    },
    "quick_actions": {
      "title": "Quick Actions",
      "upload_report": {
        "title": "Upload Report",
        "description": "Submit verification report"
      },
      "schedule_validation": {
        "title": "Schedule Validation",
        "description": "Book project assessment"
      },
      "update_declaration": {
        "title": "Update Declaration",
        "description": "Modify impartiality statement"
      }
    }
  },
  "register_page": {
    "breadcrumb": {
      "home": "Home",
      "registration": "Registration",
      "auditor_registration": "Auditor Registration"
    },
    "hero": {
      "title": "Auditor Registration",
      "subtitle": "Designated Operational Entity (DOE) Accreditation",
      "registration_fee": "Registration Fee: $3,000.00"
    },
    "form": {
      "title": "DOE Registration Form",
      "subtitle": "Complete all required fields to register as a Designated Operational Entity",
      "step_progress": "Step 1 of 3",
      "entity_information": {
        "title": "Entity Information",
        "entity_name": "Entity Name",
        "entity_name_placeholder": "Enter legal entity name",
        "country": "Country of Incorporation",
        "select_country": "Select Country",
        "registration_number": "Registration Number",
        "registration_number_placeholder": "Enter legal registration number",
        "contact_email": "Contact Email",
        "contact_email_placeholder": "e.g. contact{'@'}entity.com",
        "phone_number": "Phone Number",
        "phone_number_placeholder": "e.g. +1 (555) 123-4567",
        "website": "Website",
        "website_placeholder": "e.g. https://www.entity.com",
        "address": "Physical Address",
        "address_placeholder": "Enter complete physical address"
      },
      "accreditation_details": {
        "title": "Accreditation Details",
        "accreditation_body": "Accreditation Body",
        "select_body": "Select Accreditation Body",
        "accreditation_number": "Accreditation Number",
        "accreditation_number_placeholder": "Accreditation certificate number",
        "valid_until": "Accreditation Valid Until",
        "iso_standard": "ISO Standard",
        "select_iso": "Select ISO Standard"
      },
      "sectoral_scope": {
        "title": "Sectoral Scope Selection",
        "info_title": "Select Your Areas of Expertise",
        "info_description": "Choose all sectoral scopes where your entity has accreditation and expertise to validate carbon credit projects.",
        "energy_renewable": "Energy (Renewable)",
        "energy_renewable_desc": "Solar, Wind, Hydro",
        "energy_efficiency": "Energy Efficiency",
        "energy_efficiency_desc": "Buildings, Industry",
        "transport": "Transport",
        "transport_desc": "Modal shift, Efficiency",
        "manufacturing": "Manufacturing",
        "manufacturing_desc": "Process optimization",
        "chemical_industry": "Chemical Industry",
        "chemical_industry_desc": "Process emissions",
        "construction": "Construction",
        "construction_desc": "Materials, Methods",
        "mining_mineral": "Mining/Mineral",
        "mining_mineral_desc": "Extraction, Processing",
        "metal_production": "Metal Production",
        "metal_production_desc": "Steel, Aluminum",
        "fugitive_emissions": "Fugitive Emissions",
        "fugitive_emissions_desc": "Oil, Gas, Coal",
        "solvents": "Solvents",
        "solvents_desc": "Industrial use",
        "waste_management": "Waste Management",
        "waste_management_desc": "Disposal, Treatment",
        "afolu": "AFOLU",
        "afolu_desc": "Agriculture, Forestry",
        "chemical_industry_placeholder": "e.g. Nitric acid production",
        "construction_placeholder": "e.g. Cement production",
        "mining_mineral_placeholder": "e.g. Coal mining",
        "metal_production_placeholder": "e.g. Iron and steel production",
        "fugitive_emissions_placeholder": "e.g. Methane from natural gas",
        "solvents_placeholder": "e.g. Paint application",
        "waste_management_placeholder": "e.g. Landfill gas recovery"
      },
      "documents": {
        "title": "Required Documents",
        "accreditation_certificate": "Accreditation Certificate",
        "risk_framework": "Risk Management Framework",
        "declaration_impartiality": "Declaration of Impartiality",
        "upload_instructions": "Click to upload or drag and drop",
        "file_requirements": "PDF, max 10MB"
      },
      "declarations": {
        "title": "Declarations & Terms"
      }
    }
  }
}